// O ARQUIVO MENSAL DA ASSALCE — "Layout do Arquivo de Carga de Averbacoes"
// (PDF da ASSALCE), conferido contra o `ASS202609.txt` real (#165).
//
// Largura fixa, 38 posicoes, sem cabecalho, um espaco entre os campos. ASCII,
// CRLF. A competencia vem do nome do arquivo: `ASS` + `AAAAMM`.
//
// `CAMPOS_ASSALCE` e' a UNICA tabela de posicoes: a largura da linha, os
// trechos que o tradutor le e as posicoes do documento tecnico saem dela.
// Duas tabelas a mao divergiriam na primeira mudanca de campo, e o documento
// que a ASSALCE le diria uma posicao que o tradutor nao usa mais.
import { larguraTotal } from "../forma/largura-fixa.js";
export const ASSALCE_ENTRADA_VERSAO = "1.0";
/** `ASS202609.TXT` — a competencia e' o que vem depois de `ASS`. */
export const NOME_ARQUIVO_ASSALCE = /^ASS(\d{6})\.TXT$/i;
/** `0006604,10`: virgula decimal, zeros a esquerda, sem sinal. */
export const VALOR_ASSALCE = { decimal: "virgula", sinal: "nenhum", zerosAEsquerda: true };
export const CAMPOS_ASSALCE = [
    { nome: "matricula", inicio: 1, largura: 6, alinhamento: "direita", preenchimento: "0" },
    { nome: "folha", inicio: 8, largura: 2, alinhamento: "direita", preenchimento: "0" },
    { nome: "rubrica", inicio: 11, largura: 3 },
    { nome: "valor", inicio: 15, largura: 10, alinhamento: "direita", preenchimento: "0" },
    { nome: "referencia", inicio: 26, largura: 13 },
];
/** Toda linha tem 38 posicoes: o fim do ultimo campo. E' o que `reconhecer` confere no conteudo. */
export const LARGURA_LINHA_ASSALCE = larguraTotal(CAMPOS_ASSALCE);
/** O campo pelo nome. Lanca so' para nome que a tabela nao tem: erro de quem escreveu o codigo. */
export function campoAssalce(nome) {
    const c = CAMPOS_ASSALCE.find((x) => x.nome === nome);
    if (!c)
        throw new Error(`campo "${nome}" nao existe no layout da ASSALCE`);
    return c;
}
const posicoes = (nome) => {
    const c = campoAssalce(nome);
    return `Posições ${c.inicio} a ${c.inicio + c.largura - 1} (${c.largura}).`;
};
export const COLUNAS_ASSALCE = [
    {
        nome: "matricula",
        coluna: 1,
        kind: "num",
        obrigatorio: true,
        largura: campoAssalce("matricula").largura,
        preenche: "zeros",
        descricao: `${posicoes("matricula")} Matrícula do associado, com zeros à esquerda (\`001476\`). Casa com o cadastro sem os zeros.`,
    },
    {
        nome: "folha",
        coluna: 2,
        kind: "num",
        obrigatorio: true,
        largura: campoAssalce("folha").largura,
        preenche: "zeros",
        descricao: `${posicoes("folha")} Folha funcional (FF) da ALECE, com zero à esquerda (\`03\`).`,
    },
    {
        nome: "rubrica",
        coluna: 3,
        kind: "codigo",
        obrigatorio: true,
        largura: campoAssalce("rubrica").largura,
        descricao: `${posicoes("rubrica")} Código da averbação: a rubrica (RUB) da ALECE.`,
    },
    {
        nome: "valor",
        coluna: 4,
        kind: "dinheiro",
        obrigatorio: true,
        largura: campoAssalce("valor").largura,
        preenche: "zeros",
        decimal: VALOR_ASSALCE.decimal,
        descricao: `${posicoes("valor")} Valor do mês, com vírgula decimal e zeros à esquerda (\`0006604,10\`). Valor zero é descartado.`,
    },
    {
        nome: "referencia",
        coluna: 5,
        kind: "alfa",
        obrigatorio: false,
        largura: campoAssalce("referencia").largura,
        preenche: "espacos",
        descricao: `${posicoes("referencia")} \`MM/AA a MM/AA\` na averbação com prazo; espaços nas demais.`,
    },
];
//# sourceMappingURL=assalce-colunas.js.map